export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20crimson%20and%20deep%20black%20gradients%2C%20subtle%20film%20grain%20texture%2C%20dramatic%20lighting%20like%20movie%20theater%20projector%20beam%2C%20elegant%20minimal%20composition%20with%20soft%20glow%20accents%2C%20no%20text%20or%20people%2C%20atmospheric%20and%20immersive%20cinema%20vibe&width=1800&height=1200&seq=hero-bg-movie-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <i className="ri-fire-fill text-primary-400 text-sm"></i>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">每日更新 · 秒播不卡顿</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-50 leading-tight mb-4">
              91电影
              <span className="block text-primary-400 text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mt-2">
                高清免费在线影院速播平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 mt-6">
              91电影在线观看与在线播放直达站，专注国产热门大片每日更新。
              无需注册、无需付费，打开即播，高清流畅不卡顿。覆盖动作、喜剧、
              悬疑、科幻等全类型片库，支持多设备同步观影，随时随地畅享影院级
              观影体验。本周热播《烈火追击》《暗夜追踪》等最新国产力作已上线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                <span className="text-sm text-foreground-300">今日已更新 <strong className="text-accent-400 font-semibold">36</strong> 部</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-movie-2-line text-accent-400 text-sm"></i>
                <span className="text-sm text-foreground-300">片库总量 <strong className="text-accent-400 font-semibold">12,000+</strong></span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400 text-sm"></i>
                <span className="text-sm text-foreground-300">安全无广告弹窗</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-200/60 text-foreground-200 font-medium text-sm rounded-full hover:bg-background-300/60 transition-colors border border-background-300/40 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/30 aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20abstract%20art%20with%20warm%20lighting%2C%20film%20reel%20and%20projector%20beam%20motifs%2C%20dark%20dramatic%20atmosphere%20with%20crimson%20and%20gold%20accents%2C%20elegant%20minimal%20composition%2C%20no%20recognizable%20faces%2C%20artistic%20cinema%20poster%20style%20with%20soft%20textures&width=900&height=675&seq=hero-visual-movie-2026&orientation=landscape"
                  alt="91电影 - 高清在线影院"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/30 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                  <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-950/70 backdrop-blur-sm">
                    <i className="ri-play-circle-fill text-primary-400 text-sm"></i>
                    <span className="text-xs font-medium text-foreground-200 whitespace-nowrap">正在热播</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}